import { Component, ErrorInfo } from "react";
import { jsLogsPath } from "@shared/constants";

export default class ErrorBoundary extends Component {
  state = { hasError: false };

  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  // error: any
  static getDerivedStateFromError() {
    // Обновить состояние с тем, чтобы следующий рендер показал запасной UI.
    //console.log('getDerivedStateFromError', Object.keys(error));
    //console.log(error.message, error.stack, error.stacktrace, error.filename, error.error);
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("error", error);
    console.error("errorInfo", errorInfo);
    errorSend(error);
    errorSend({ ...error, stack: errorInfo.componentStack });
  }

  render() {
    if (this.state.hasError) {
      // Можно отрендерить запасной UI произвольного вида
      return <div>Что-то пошло не так.</div>;
    }
    // eslint-disable-next-line react/prop-types
    return this.props.children;
  }
}

function errorSend(error: Error) {
  if (!error.stack || !error.message) return;
  const line = [
    "line=" + 10 + ":" + 0,
    "message=" + encodeURIComponent(error.message + " [" + error.name + "]"),
    "source=" + encodeURIComponent(""),
    "stack=" + encodeURIComponent(error.stack || ""),
    "time=" + new Date().getTime()
  ].join("&");

  if (navigator.sendBeacon) {
    navigator.sendBeacon(`${jsLogsPath}error?` + line, null);
  } else if ("fetch" in window) {
    fetch(`${jsLogsPath}error?` + line, { method: "POST" }).catch(() => void 0);
  }
}
